// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1LMru","label":"Category_label__2q9g0","content":"Category_content__1TkCH","header":"Category_header__1HlVZ","location":"Category_location__3Xrfg"};